/*
* Copyright (c) 2009-2019. Authors: see NOTICE file.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

import _ from 'lodash';

/**
 * Return a Regexp based on the provided search string, and using * as a wildcard character.
 * @param {String} str The string entered by the user
 * @return {RegExp}
 */
export function getWildcardRegexp(str) {
  let escapedString = _.escapeRegExp(str); // escape all RegExp special characters (only * should have a special behaviour)
  return new RegExp('(' + escapedString.split('\\*').join('.*') + ')', 'i');
}
